import { render, staticRenderFns } from "./OptionsGroup.vue?vue&type=template&id=fa88e1e2&scoped=true&lang=pug&"
import script from "./OptionsGroup.vue?vue&type=script&lang=js&"
export * from "./OptionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./OptionsGroup.vue?vue&type=style&index=0&id=fa88e1e2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88e1e2",
  null
  
)

export default component.exports